import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/site";
import { Reveal } from "./Reveal";

export const ChannelButtons = ({ dark = false }) => {
  const base = dark
    ? "border-sand/30 text-sand hover:bg-sand hover:text-graphite"
    : "border-graphite/30 text-graphite hover:bg-graphite hover:text-sand";
  return (
    <div className="flex flex-wrap gap-4">
      <a href={CONTACT.phoneHref} data-testid="cta-phone-button" className={`border px-6 py-3 text-[12px] uppercase tracking-[0.18em] transition-colors duration-500 ${base}`}>
        Обади се
      </a>
      <a href={CONTACT.viber} data-testid="cta-viber-button" className={`border px-6 py-3 text-[12px] uppercase tracking-[0.18em] transition-colors duration-500 ${base}`}>
        Viber
      </a>
      <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-button" className={`border px-6 py-3 text-[12px] uppercase tracking-[0.18em] transition-colors duration-500 ${base}`}>
        WhatsApp
      </a>
    </div>
  );
};

export const CTABand = () => (
  <section className="bg-burgundy text-sand" data-testid="cta-band">
    <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12 lg:py-28">
      <Reveal>
        <p className="text-[11px] uppercase tracking-[0.35em] text-sand/60">Личен разговор</p>
        <h2 className="mt-8 max-w-3xl font-serif text-4xl font-light leading-[1.1] sm:text-5xl lg:text-6xl">
          Готови ли сте да отделите време <em className="italic">за себе си?</em>
        </h2>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-sand/70">
          Запазете своята лична консултация – спокойно, дискретно и без никакъв ангажимент. Ще отговоря на
          всеки ваш въпрос.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <Link
            to="/kontakti"
            data-testid="cta-band-book-button"
            className="border border-sand bg-transparent px-10 py-4 text-[12px] uppercase tracking-[0.2em] text-sand transition-colors duration-[400ms] hover:bg-sand hover:text-burgundy"
          >
            Запазете безплатна консултация
          </Link>
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-band-phone-link"
            className="flex items-center gap-3 text-sm tracking-wide text-sand/80 transition-colors duration-500 hover:text-sand"
          >
            <Phone size={16} strokeWidth={1.5} /> {CONTACT.phoneDisplay}
          </a>
          <span className="hidden items-center gap-3 text-sm text-sand/50 md:flex">
            <MessageCircle size={16} strokeWidth={1.5} />
            <a href={CONTACT.viber} data-testid="cta-band-viber-link" aria-label="Пишете ни във Viber" className="underline-offset-4 transition-colors duration-500 hover:text-sand hover:underline">
              Viber
            </a>
            <span>и</span>
            <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="cta-band-whatsapp-link" aria-label="Пишете ни в WhatsApp" className="underline-offset-4 transition-colors duration-500 hover:text-sand hover:underline">
              WhatsApp
            </a>
            <span>на същия номер</span>
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export const Marquee = ({ items }) => {
  const row = items.map((t, i) => (
    <span key={i} className="mx-8 flex items-center gap-8 whitespace-nowrap">
      <span className="font-serif text-2xl font-light italic text-graphite/60 lg:text-3xl">{t}</span>
      <span className="h-1.5 w-1.5 rotate-45 bg-burgundy/50" />
    </span>
  ));
  return (
    <div className="overflow-hidden border-y border-hairline py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
